import { useEffect } from "react";
import toast from "react-hot-toast";

const SUPPORT_EMAIL = "recruitglance@gmail.com";
const FEATURE_LIMIT_MESSAGE = "Preview this feature and upgrade when you are ready to use it.";

export const actionFailureMessage = (actionName, detail = "") => {
  const cleanDetail = String(detail || "").trim();

  if (cleanDetail.toLowerCase().includes("your plan does not allow access")) {
    return FEATURE_LIMIT_MESSAGE;
  }

  if (cleanDetail) {
    return cleanDetail;
  }

  return `${actionName} was not successful. Please try again. If this keeps happening, contact ${SUPPORT_EMAIL}.`;
};

export const actionSlowMessage = (actionName) =>
  `${actionName} is taking longer than expected. You can stay on this page or try again shortly.`;

export function useLongActionNotice(active, actionName, delayMs = 45000) {
  useEffect(() => {
    if (!active) return undefined;

    const timer = setTimeout(() => {
      toast(actionSlowMessage(actionName), {
        id: `long-action-${actionName}`,
      });
    }, delayMs);

    return () => clearTimeout(timer);
  }, [active, actionName, delayMs]);
}
